import React from "react";
import styled from "styled-components";
import { MdMenu, MdShoppingCart } from "react-icons/md";
import { Link } from "react-router-dom";
import { useSidebarContext } from "../context/sidebar_context";
import { useCartContext } from "../context/cart_context";
import h1logo from "../../../assets/images/h1logo.png";

const Navbar = () => {
  const { total_items } = useCartContext();
  const { openSidebar } = useSidebarContext();

  return (
    <NavbarWrapper className="bg-white flex">
      <div className="container w-100">
        <div className="brand-and-toggler flex flex-between w-100">
          <Link to="/" className="navbar-brand text-uppercase ls-1 fw-8">
            <img src={h1logo} alt="Code Compass" />
          </Link>

          <div className="menu">
            <ul>
              <li>
                <a href="/problemset">ProblemSet</a>
              </li>
              <li>
                <a href="/login">Logout</a>
              </li>
            </ul>
          </div>

          <div className="navbar-btns flex">
            <Link to="/cart" className="cart-btn">
              <MdShoppingCart />
              <span className="item-count-badge">{total_items}</span>
            </Link>
            {/* <button
              type="button"
              className="sidebar-open-btn"
              onClick={() => openSidebar()}
            >
              <MdMenu />
            </button> */}
          </div>
        </div>
      </div>
    </NavbarWrapper>
  );
};

const NavbarWrapper = styled.nav`
  height: 80px;
  box-shadow: rgba(50, 50, 93, 0.15) 0px 16px 12px -2px,
    rgba(0, 0, 0, 0.2) 0px 3px 7px -3px;

  .navbar-brand {
    font-size: 23px;
    span {
      color: var(--clr-orange);
    }
  }
  img {
    width: 200px;
    height: 80px;
    object-fit: cover;
    object-position: center;
    margin-left: 10rem;
  }

  li {
    list-style: none;
  }
  .menu {
    width: 400px;
    grid-column: 3/3;
    margin-right: 3rem;
    margin-top: 1rem;
    align-items: center;
    justify-content: center;
    align-items: center;
  }

  .menu ul {
    align-items: right;
    display: flex;
    justify-content: space-around;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
  }

  .menu ul :hover {
    color: #336cff;
  }

  .hamburger-menu {
    display: none;
  }

  a {
    text-decoration: none;

    color: #000;
  }

  .logo {
    display: flex;
    grid-column: 1/2;
    align-items: center;
    justify-content: center;
    margin-left: 3rem;
  }
  .cart-btn {
    margin-right: 18px;
    font-size: 23px;
    position: relative;
    .item-count-badge {
      background-color: var(--clr-orange);
      position: absolute;
      right: -10px;
      top: -10px;
      font-size: 12px;
      font-weight: 700;
      display: block;
      width: 23px;
      height: 23px;
      color: var(--clr-white);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .sidebar-open-btn {
    transition: all 300ms ease-in-out;
    &:hover {
      opacity: 0.7;
    }
  }
`;

export default Navbar;
